import * as types from './types'
import actions from './actions'
import getters from './getters.js'
import Vue from 'vue'
import { generalHelpers } from '@/_helpers'
import Pallet from '@/plugins/pallet-recommendation.js'
import { availableCustomPallets, availableEuroPallet } from '@/plugins/available-pallets.js'


const state = {
  checkedOnPage: {},
  actualPage: 0,
  selectedDrop: null,
  selectedDropDetails: null,
  dropUnitsHash: {},
  dropUnitsHashKeys: {},
  selectedDropDetailsView: null,
  checkedUnits: [],
  selectedUnit: null,
  hoveredUnit: null,
  sortedBy: null,
  filteredByOrderRef: [],
  filteredByCustomerRef: [],
  filteredByItemCategory: [],
  toggledOrders: [],
  isLoading: false,
  isExportLoading: false,
  availablePallets: null
}
const mutations = {
  [types.SELECT_ITEM] (state, action) {
    if (state.selectedDrop === action.itemID) {
      state.selectedDrop = null
      state.selectedDropDetails = null
    } else {
      state.selectedDrop = action.itemID
      state.selectedDropDetails = action.details
    }
  },
  [types.UPDATE_ITEM] (state, action) {
    state.selectedDropDetails = { ...state.selectedDropDetails, units: action.units }
  },
  [types.UPDATE_DROP_VOLUME_WEIGHT_ADD] (state, action) {
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, volume: action.volume, weight: state.selectedDropDetailsView.weight + action.weight }
  },
  [types.UPDATE_DROP_VOLUME_WEIGHT_REMOVE] (state, action) {
    let removedUnitVolume = state.dropUnitsHash[action.unitID].dimensions.length * 0.01 * state.dropUnitsHash[action.unitID].dimensions.width * 0.01 * state.dropUnitsHash[action.unitID].dimensions.height * 0.01
    let removedUnitWeight = state.dropUnitsHash[action.unitID].weight
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, volume: state.selectedDropDetailsView.volume - removedUnitVolume, weight: state.selectedDropDetailsView.weight - removedUnitWeight }
  },
  [types.UPDATE_DROP_UNIT_TYPE_COUNT] (state, action) {
    let countArray = state.dropUnitsHashKeys[action.dropID].map((key) => {
      return state.dropUnitsHash[key].type
    })
    let unitsTypes = {}
    let unitsCount = []
    countArray.forEach((item) => {
      unitsTypes[item] = unitsTypes[item] || 0
      unitsTypes[item]++
    })
    Object.keys(unitsTypes).forEach((key) => {
      unitsCount.push({
        type: key,
        count: unitsTypes[key]
      })
    })
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, unitsCount: unitsCount }
  },
  [types.SELECT_DROP_DETAILS_VIEW] (state, action) {
    state.selectedDropDetailsView = action.drop
  },
  [types.SELECT_DROP_DETAILS_VIEW_UNITS] (state, action) {
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, units: action.units }
  },
  [types.TOGGLE_ALL] (state, action) {
    if (state.checkedOnPage[action.page] !== undefined && state.checkedOnPage[action.page].length > 0) {
      Vue.set(state.checkedOnPage, action.page, [])
    } else {
      if (state.checkedOnPage[action.page] === undefined) {
        Vue.set(state.checkedOnPage, action.page, [])
      }
      action.hitsOnPage.forEach(el => {
        state.checkedOnPage[action.page].push(el)
      })
    }
  },
  [types.TOGGLE_ITEM] (state, action) {
    if (state.checkedOnPage[action.page] === undefined) {
      Vue.set(state.checkedOnPage, action.page, [])
    }
    const index = state.checkedOnPage[action.page].indexOf(action.itemID)
    if (index > -1) {
      state.checkedOnPage[action.page].splice(index, 1)
    } else {
      state.checkedOnPage[action.page].push(action.itemID)
    }
  },
  [types.ADD_DROP_UNITS] (state, action) {
    Object.keys(state.dropUnitsHash).forEach((key) => {
      delete state.dropUnitsHash[key]
    })
    Object.keys(state.dropUnitsHashKeys).forEach((key) => {
      delete state.dropUnitsHashKeys[key]
    })
    let allUnits = []
    if (action.isTree) {
      allUnits = [...action.units, ...action.units.reduce(
        (arr, elem) => {
          for (const c of elem.children) {
            if (c.children !== undefined) {
              for (const a of c.children) {
                arr.push(a)
              }
            } else {
              for (const a of c.units) {
                arr.push(a)
              }
            }
            arr.push(c)
          }
          return arr
        }, []
      )]
    } else {
      allUnits = [...action.units]
    }
    allUnits.forEach((unit) => {
      unit.children = []
      // Create unit order reference number
      if (unit.items !== null) {
        unit.items.forEach((item) => {
          // item.orderRef = item.ref.replace(/-\d*/g, '')
          if (unit.transport.order != null) {
            item.orderRef = unit.transport.order.seller.ref
          } else {
            item.orderRef = null
          }
        })
      }
      state.dropUnitsHash = { ...state.dropUnitsHash, [unit.id]: unit }
    })
    const hashKeyGroups = generalHelpers.groupByObjects(allUnits, 'parent')
    Object.keys(hashKeyGroups).forEach((key) => {
      state.dropUnitsHashKeys = { ...state.dropUnitsHashKeys, [key]: hashKeyGroups[key].map(({ id }) => id) }
    })
  },
  [types.ADD_DROP_UNIT] (state, action) {
    state.dropUnitsHash = { ...state.dropUnitsHash, [action.unit.id]: action.unit }
  },
  [types.ADD_NEW_UNIT_PARENT_ID] (state, action) {
    action.units.forEach((selectedUnit, unitIndex) => {
      // state.dropUnitsHash[selectedUnit.id] = { ...state.dropUnitsHash[selectedUnit.id], parent: action.parent }
      const index = state.dropUnitsHashKeys[action.oldParent].indexOf(selectedUnit)
      state.dropUnitsHashKeys[action.oldParent].splice(index, 1)
      if (state.dropUnitsHashKeys[action.parent] === undefined) {
        state.dropUnitsHashKeys[action.parent] = []
      }
      if (state.dropUnitsHashKeys[action.parent].indexOf(selectedUnit) < 0) {
        state.dropUnitsHashKeys[action.parent].push(selectedUnit)
      }
    })
  },
  [types.CHANGE_UNIT_PARENT_ID] (state, action) {
    action.units.forEach((selectedUnit, unitIndex) => {
      state.dropUnitsHash[selectedUnit.id] = { ...state.dropUnitsHash[selectedUnit.id], parent: action.parent }
      const index = state.dropUnitsHashKeys[action.oldParent].indexOf(selectedUnit.id)
      state.dropUnitsHashKeys[action.oldParent].splice(index, 1)
      if (state.dropUnitsHashKeys[action.parent].indexOf(selectedUnit.id) < 0) {
        state.dropUnitsHashKeys[action.parent].push(selectedUnit.id)
      }
    })
    // Calculating new dims with every change
    let childrenArray = []
    state.dropUnitsHashKeys[action.containerID].forEach((key) => {
      childrenArray.push(state.dropUnitsHash[key])
    })
    if (state.dropUnitsHash[action.containerID].type != null) {
      let calculateParentWeight = 0
      childrenArray.forEach((unit) => {
        calculateParentWeight += unit.weight
      })
      state.dropUnitsHash = { ...state.dropUnitsHash, [action.containerID]: { ...state.dropUnitsHash[action.containerID], weight: (calculateParentWeight + state.dropUnitsHash[action.containerID].packagingWeight)} }
    }
    if (state.dropUnitsHash[action.containerID].type === 'CustomPallet') {
      let pallet = new Pallet(childrenArray)
      const calculateNewDimensions = pallet.calculateRecommendations().recomendedDims
      state.dropUnitsHash = { ...state.dropUnitsHash, [action.containerID]: { ...state.dropUnitsHash[action.containerID], dimensions: calculateNewDimensions, warnings: pallet.warnings } }
    } else {
      let pallet = new Pallet(childrenArray, 'EurPallet')
      const calculateNewDimensions = pallet.calculateRecommendations().recomendedDims
      calculateNewDimensions['width'] = state.dropUnitsHash[action.containerID].dimensions.width
      calculateNewDimensions['length'] = state.dropUnitsHash[action.containerID].dimensions.length
      state.dropUnitsHash = { ...state.dropUnitsHash, [action.containerID]: { ...state.dropUnitsHash[action.containerID], dimensions: calculateNewDimensions, warnings: pallet.warnings } }
    }
  },
  [types.TOGGLE_UNIT] (state, action) {
    const index = state.checkedUnits.indexOf(action.unitID)
    if (index > -1) {
      state.checkedUnits.splice(index, 1)
    } else {
      state.checkedUnits.push(action.unitID)
    }
  },
  [types.TOGGLE_SHIFT_UNIT] (state, action) {
    const index = state.checkedUnits.indexOf(action.unitID)
    if (index < 0) {
      state.checkedUnits.push(action.unitID)
    }
  },
  [types.TOGGLE_ALL_UNITS] (state, action) {
    switch (action.toggleState) {
      case 'all':
        state.checkedUnits = action.units
        break
      case 'remove':
        state.checkedUnits = []
        break
    }
  },
  [types.SELECT_UNIT] (state, action) {
    if (action.unit === undefined || action.unit === null) {
      state.selectedUnit = null
    } else if (state.selectedUnit === null) {
      if (state.dropUnitsHashKeys[action.unit.id] !== undefined) {
        let children = []
        state.dropUnitsHashKeys[action.unit.id].forEach((unitID) => {
          children.push(state.dropUnitsHash[unitID])
        })
        state.selectedUnit = { ...action.unit, children: children }
      } else {
        state.selectedUnit = { ...action.unit }
      }
    } else if (state.selectedUnit.id === action.unit.id) {
      state.selectedUnit = null
    } else {
      if (state.dropUnitsHashKeys[action.unit.id] !== undefined) {
        let children = []
        state.dropUnitsHashKeys[action.unit.id].forEach((unitID) => {
          children.push(state.dropUnitsHash[unitID])
        })
        state.selectedUnit = { ...action.unit, children: children }
      } else {
        state.selectedUnit = { ...action.unit }
      }
    }
  },
  [types.REMOVE_UNIT] (state, action) {
    if (state.dropUnitsHashKeys[action.unitID] !== undefined) {
      state.dropUnitsHashKeys[action.unitID].forEach((key) => {
        state.dropUnitsHash[key] = { ...state.dropUnitsHash[key], parent: action.dropID }
        const childUnitIndex = state.dropUnitsHashKeys[action.dropID].indexOf(key)
        if (childUnitIndex < 0) {
          state.dropUnitsHashKeys[action.dropID].push(key)
        }
      })
    }

    const parentArrayRemovedUnitIndex = state.dropUnitsHashKeys[state.dropUnitsHash[action.unitID].parent].indexOf(action.unitID)
    if (parentArrayRemovedUnitIndex > -1) {
      state.dropUnitsHashKeys[state.dropUnitsHash[action.unitID].parent].splice(parentArrayRemovedUnitIndex, 1)
    }

    if (state.dropUnitsHash[action.unitID] !== undefined) {
      delete state.dropUnitsHash[action.unitID]
    }
    if (state.dropUnitsHashKeys[action.unitID] !== undefined) {
      delete state.dropUnitsHashKeys[action.unitID]
    }
  },
  [types.CHANGE_ACTUAL_PAGE] (state, page) {
    state.actualPage = page
  },
  // [types.CHANGE_UNIT_ORDERING] (state, action) {
  //   console.log(action)
  // },
  [types.HOVERED_UNIT] (state, action) {
    state.hoveredUnit = action.hoveredID
  },
  [types.SORT_DETAIL_UNITS] (state, action) {
    state.sortedBy = action.sortedBy
  },
  [types.FILTER_ORDER_REF_DETAIL_UNITS] (state, action) {
    const index = state.filteredByOrderRef.indexOf(action.orderRef)
    if (action.enable) {
      state.filteredByOrderRef.push(action.orderRef)
    } else {
      state.filteredByOrderRef.splice(index, 1)
    }
  },
  [types.FILTER_CUSTOMER_REF_DETAIL_UNITS] (state, action) {
    const index = state.filteredByCustomerRef.indexOf(action.customerRef)
    if (action.enable) {
      state.filteredByCustomerRef.push(action.customerRef)
    } else {
      state.filteredByCustomerRef.splice(index, 1)
    }
  },
  [types.FILTER_ITEM_CATEGORY_DETAIL_UNITS] (state, action) {
    const index = state.filteredByItemCategory.indexOf(action.category)
    if (action.enable) {
      state.filteredByItemCategory.push(action.category)
    } else {
      state.filteredByItemCategory.splice(index, 1)
    }
  },
  [types.LOADING_NEW_DROPS] (state, action) {
    state.isLoading = action.isLoading
    state.isExportLoading = action.isExportLoading
  },
  [types.TOGGLE_DROP_ORDER] (state, action) {
    if (action.toggleState === 'remove') {
      state.toggledOrders = []
    } else {
      const index = state.toggledOrders.indexOf(action.orderRef)
      if (index < 0) {
        state.toggledOrders.push(action.orderRef)
      } else {
        state.toggledOrders.splice(index, 1)
      }
    }
  },
  [types.SET_CUSTOM_NAME] (state, action) {
    state.selectedUnit = { ...state.selectedUnit, ref: action.name }
    const unitUpdate = state.dropUnitsHash[action.id]
    state.dropUnitsHash[action.id] = { ...unitUpdate, ref: action.name }
  },
  [types.SET_CUSTOM_WEIGHT] (state, action) {
    state.selectedUnit = { ...state.selectedUnit, weight: action.weight, packagingWeight: action.packagingWeight }
    const unitUpdate = state.dropUnitsHash[action.id]
    state.dropUnitsHash[action.id] = { ...unitUpdate, weight: action.weight, packagingWeight: action.packagingWeight }
  },
  [types.SET_CUSTOM_DIMENSIONS] (state, action) {
    state.selectedUnit = { ...state.selectedUnit, dimensions: action.dimensions }
    const unitUpdate = state.dropUnitsHash[action.id]
    state.dropUnitsHash[action.id] = { ...unitUpdate, dimensions: action.dimensions }
  },
  [types.SET_CUSTOM_STATUS] (state, action) {
    state.selectedUnit = { ...state.selectedUnit, status: action.status }
    const unitUpdate = state.dropUnitsHash[action.id]
    state.dropUnitsHash[action.id] = { ...unitUpdate, status: action.status }
  },
  [types.SET_PALLET_CALCULATION_WARNINGS] (state, action) {
    if (action.unit.type === 'CustomPallet') {
      let pallet = new Pallet(action.unit.children)
      pallet.calculateRecommendations()
      state.dropUnitsHash = { ...state.dropUnitsHash, [action.unit.id]: { ...state.dropUnitsHash[action.unit.id], warnings: pallet.warnings } }
    } else {
      let pallet = new Pallet(action.unit.children, 'EurPallet')
      pallet.calculateRecommendations()
      state.dropUnitsHash = { ...state.dropUnitsHash, [action.unit.id]: { ...state.dropUnitsHash[action.unit.id], warnings: pallet.warnings } }
    }
  },
  [types.SET_UNIT_CUSTOMER_REF_NUMBER] (state, action) {
    const dropUnits = state.dropUnitsHash
    Object.keys(dropUnits).forEach((key) => {
      const unit = dropUnits[key]
      if (unit.transport.order != null) {
        const orderIndex = action.orders.findIndex((order) => {
          return order.code === unit.transport.order
        })
        if (orderIndex >= 0) {
          state.dropUnitsHash = { ...state.dropUnitsHash, [unit.id]: { ...state.dropUnitsHash[unit.id], customerRef: action.orders[orderIndex].customer_ref } }
        }
      }
    })
  },
  [types.SET_SELECTED_DROP_ORIGIN_LOCATION] (state, action) {
    const origin = { ...state.selectedDropDetailsView.origin, ...action.location }
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, origin }
  },
  [types.SET_SELECTED_DROP_DESTINATION_LOCATION] (state, action) {
    const destination = { ...state.selectedDropDetailsView.destination, ...action.location }
    state.selectedDropDetailsView = { ...state.selectedDropDetailsView, destination }
  },
  [types.SET_AVAILABLE_PALLETS] (state, action) {
    const units = state.checkedUnits.map((key) => {
      return state.dropUnitsHash[key]
    })
    state.availablePallets = [...availableCustomPallets(units), ...availableEuroPallet(units)]
  }

}
export default {
  state,
  mutations,
  actions,
  getters
}
